import { React, useRef, useState, useEffect } from "react";

import logo from "../Images/logo.png";

import "./new-register.css";
import "./new-redeemption.css";

import "bootstrap/dist/css/bootstrap.min.css";
import secureLocalStorage from "react-secure-storage";

import { useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import UserformService from "../services/userform.service";

import $ from "jquery";

import { toast } from "react-toastify";
import { useLayoutEffect } from "react";
import "select2/dist/css/select2.min.css";
import "select2";
import Swal from "sweetalert2";
import NotFound from "./admin/includes/NotFound";

function Validating({ setToken }) {
  const TITLE = process.env.REACT_APP_API_SITE_TITLE;
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");

  const navigate = useNavigate();

  secureLocalStorage.removeItem("registerform");
  useEffect(() => {
    if (token) {
      setToken(token);
      setTimeout(() => {
        navigate("/register");
      }, 200);
    }
  }, []);

  if (!token) {
    return <NotFound />;
  }

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className={`loader in`}>
        <div className="spinner-border main-spin"></div>
      </div>

      {/* <Footer2 /> */}
    </>
  );
}
export default Validating;
